<div class="h-full flex flex-col">
  <div class="border-b px-4 py-2 flex-none flex items-center">
    <mat-icon
      svgIcon="mat:drag_indicator"
      class="icon-sm cursor-move mr-2 slc-color-brand"
      cdkDragHandle
    ></mat-icon>

    <h2 class="title flex-auto" [class.hidden]="!card()?.titulo">
      {{ card()?.titulo }}
    </h2>
    <h2 class="title flex-auto" [class.hidden]="card()?.titulo">
      <div class="w-8/12 slc-skeleton"></div>
    </h2>

    <!-- Fullscreen -->
    @if(fullScreenHabilitado()) {
    <button
      class="ml-4 flex-none"
      mat-icon-button
      matTooltip="Retrair"
      type="button"
      (click)="alternarFullscreen.emit()"
    >
      <mat-icon svgIcon="mat:close_fullscreen"></mat-icon>
    </button>

    } @else {

    <button
      (click)="alternarFullscreen.emit()"
      class="ml-4 flex-none slc-expandir"
      mat-icon-button
      matTooltip="Expandir"
      type="button"
    >
      <mat-icon svgIcon="mat:open_in_full"></mat-icon>
    </button>
    }

    <button
      class="flex-none slc-mais-opcoes"
      mat-icon-button
      matTooltip="Mais Opções"
      type="button"
      [matMenuTriggerFor]="maisOpcoesMenu"
    >
      <mat-icon svgIcon="mat:more_vert"></mat-icon>
    </button>
  </div>

  <!-- Tabela cabeçalho -->
  <div class="flex-none ml-2">
    <div class="overflow-hidden" [style.width]="'calc(100% - 14px)'">
      <table
        #tableHeader
        mat-table
        fixedLayout
        id="table-header"
        [dataSource]="[]"
      >
        @for (coluna of colunas(); track coluna.id) {
        <ng-container [matColumnDef]="coluna.id">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.width]="'var(--col-size-' + $index + ')'"
            [style.max-width]="'var(--col-size-' + $index + ')'"
            [style.min-width]="'var(--col-size-' + $index + ')'"
            class="slc-header-cell"
          >
            <div class="flex items-center justify-start">
              <div
                class="mr-2"
                [class.text-center]="coluna.tipoDado === 'valor'"
              >
                {{ coluna.descricao }}
              </div>
              <div class="flex flex-col justify-center items-center w-12">
                <ng-container
                  *ngTemplateOutlet="
                    statusColuna;
                    context: { $implicit: coluna }
                  "
                ></ng-container>
                <button
                  mat-icon-button
                  type="button"
                  class="slc-action"
                  [cdkMenuTriggerFor]="menu.colunasMenu()"
                  [cdkMenuTriggerData]="{ $implicit: coluna }"
                >
                  <mat-icon svgIcon="mat:more_vert"></mat-icon>
                </button>
              </div>
            </div>
          </th>
        </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="colunasIds()"></tr>
      </table>
    </div>
  </div>

  <!-- Tabela dados -->
  <div class="flex-1 ml-2 overflow-hidden flex relative">
    <div
      class="overflow-hidden"
      [style.width]="'calc(100% - 14px)'"
      [style.height]="'calc(100% - 14px)'"
    >
      <table
        #tableDados
        mat-table
        fixedLayout
        id="table-dados"
        [dataSource]="linhas()"
      >
        @for (coluna of colunas(); track coluna.id) {
        <ng-container [matColumnDef]="coluna.id">
          <td
            mat-cell
            *matCellDef="let row"
            class="text-nowrap"
            [attr.data-col-index]="$index"
          >
            @if (row) {
            <!---->
            @if (coluna.tipoDado === 'valor') {
            <div class="text-right">
              {{ row.get(coluna) | number : "0.2-2" }}
            </div>
            } @else if (coluna.tipoDado === 'data' && row.get(coluna)) {
            {{
              row.get(coluna).substr(4, 2) + "/" + row.get(coluna).substr(0, 4)
            }}
            } @else {
            <div>{{ row.get(coluna) }}</div>
            }
            <!---->
            } @else {
            <div class="slc-cell-skeleton"></div>
            }
          </td>
        </ng-container>
        }
        <tr mat-row *matRowDef="let row; columns: colunasIds()"></tr>
      </table>
    </div>
    <div
      class="flex-none absolute inset-0 slc-container-dados"
      (scroll)="onTableDadosScroll($event)"
    >
      <div
        [style.height.px]="tableDadosEl()?.nativeElement.clientHeight"
        [style.width.px]="tableDadosEl()?.nativeElement.clientWidth"
      ></div>
    </div>
  </div>
</div>

<app-data-manager-menu
  #menu
  [dmController]="dmController()"
  [ocultarGrupo]="true"
  [ocultarSubtotal]="true"
></app-data-manager-menu>

<ng-template #statusColuna let-coluna>
  <div class="opacity-50 w-12 flex flex-col items-center slc-coluna-status">
    <mat-icon
      svgIcon="mat:arrow_upward"
      [class.hidden]="coluna.config.ordenacao !== 'asc'"
      class="icon-xs"
    ></mat-icon>
    <mat-icon
      svgIcon="mat:arrow_downward"
      [class.hidden]="coluna.config.ordenacao !== 'desc'"
      class="icon-xs"
    ></mat-icon>
    @if (coluna.tipoColuna !== 'dadoAdicional') {
    <mat-icon
      svgIcon="mat:functions"
      [class.hidden]="!coluna.config.total"
      class="icon-xs"
    ></mat-icon>
    }
  </div>
</ng-template>

<mat-menu #maisOpcoesMenu="matMenu">
  <button mat-menu-item (click)="onOcultarCard()">
    <mat-icon svgIcon="mat:visibility_off"></mat-icon>
    <span>Ocultar Card</span>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="dadosMenu">
    <mat-icon svgIcon="mat:storage"></mat-icon>
    <span>Dados</span>
  </button>
</mat-menu>

<mat-menu #dadosMenu>
  <mat-checkbox
    class="mat-mdc-menu-item slc-checkbox-brand"
    [checked]="origemDados()?.venda"
    (change)="
      origemDados.set({
        venda: $event.checked,
        historico: origemDados()?.historico || false
      })
    "
    >Vendas em aberto</mat-checkbox
  >
  <mat-checkbox
    class="mat-mdc-menu-item slc-checkbox-brand"
    [checked]="origemDados()?.historico"
    (change)="
      origemDados.set({
        venda: origemDados()?.venda || false,
        historico: $event.checked
      })
    "
    >Vendas histórico</mat-checkbox
  >
</mat-menu>
